(function () {

    // --- PATCH IMMAGINI NEL SHADOW DOM DI UPCART ---
    // Legge la thumb direttamente da /cart.js ad ogni chiamata

    async function patchImages() {
        const root = document.querySelector('#upCart')?.shadowRoot;
        if (!root) return;

        const res = await fetch('/cart.js');
        const cart = await res.json();

        const itemEls = root.querySelectorAll('.upcart-internal-cart-item');

        itemEls.forEach((itemEl, index) => {
            const titleLink = itemEl.querySelector('.upcart-public-component-product-tile__title-link');
            if (!titleLink) return;

            const isEligible = titleLink.innerText.toLowerCase().includes('personalizzato') ||
                            titleLink.href.includes('personalizza');
            if (!isEligible) return;

            const cartItem = cart.items[index];
            const thumbUrl = cartItem?.properties?.['_customily-thumb'];
            if (!thumbUrl) return;

            const img = itemEl.querySelector('.upcart-internal-component-product-tile__image-wrapper img');
            if (img) img.setAttribute('src', thumbUrl);
        });
    }

    // Triggera patchImages ogni volta che UpCart aggiorna il shadow DOM
    const hostObserver = new MutationObserver(() => {
        const root = document.querySelector('#upCart')?.shadowRoot;
        if (!root) return;
        patchImages();
    });

    hostObserver.observe(document.body, { childList: true, subtree: true });

    // --- CUSTOMILY ---

    function getQuantity() {
        const modal = document.querySelector(".customily-modal-container, .csh-product-customizer-modal");
        const input = modal?.querySelector(".js-quantity-field-pdp") || document.querySelector(".js-quantity-field-pdp");
        return parseInt(input?.value || "1");
    }

    function readCustomilyProperties() {
        const modal = document.querySelector(".customily-modal-container, .csh-product-customizer-modal");
        if (!modal) return {};
        const inputs = modal.querySelectorAll('[name^="properties["]');
        const props = {};
        inputs.forEach(input => {
            const match = input.name.match(/properties\[(.*?)\]/);
            if (!match) return;
            const key = match[1].trim();
            if (input.type === "radio" || input.type === "checkbox") {
                if (input.checked) props[key] = input.value || "✓";
            } else {
                const val = input.value?.trim();
                if (val) props[key] = val;
            }
        });
        return props;
    }

    // Proprietà Customily che arrivano in ritardo rispetto al click (scritte in modo asincrono)
    const PROPRIETA_IN_RITARDO = ["_customily-thumb", "_customily-preview"];

    function leggiValoreProprieta(nome) {
        const input = document.querySelector(`input[name="properties[${nome}]"]`);
        return input?.value?.trim() || "";
    }

    // Dopo l'aggiunta al carrello: aspetta le proprietà async di Customily,
    // poi aggiorna l'item via /cart/change.js e patcha l'immagine in UpCart
    async function fixCartItem(addedItem, qty, extraProps) {
        try {
            const trovate = {};
            const daTrovare = new Set(PROPRIETA_IN_RITARDO);
            let attempts = 0;

            while (attempts < 10 && daTrovare.size > 0) {
                for (const nome of Array.from(daTrovare)) {
                    const val = leggiValoreProprieta(nome);
                    if (val.startsWith("http")) {
                        trovate[nome] = val;
                        daTrovare.delete(nome);
                    }
                }
                if (daTrovare.size === 0) break;
                await new Promise(r => setTimeout(r, 400));
                attempts++;
            }

            if (daTrovare.size > 0) {
                console.warn("[CustomilyFix] Proprietà non trovate dopo polling:", Array.from(daTrovare));
            }

            Object.assign(extraProps, trovate);

            const itemKey = addedItem.key || addedItem.id;
            if (!itemKey) {
                console.error("[CustomilyFix] Impossibile determinare la key dell'item.", addedItem);
                return;
            }

            const res = await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: itemKey,
                    quantity: qty,
                    properties: { ...addedItem.properties, ...extraProps }
                }),
            });

            if (!res.ok) {
                console.error("[CustomilyFix] /cart/change.js errore:", res.status, await res.text());
                return;
            }

            patchImages();

        } catch (err) {
            console.error("[CustomilyFix] Errore:", err);
        }
    }

    // Aggancia il click sul bottone "Aggiungi al carrello" di Customily
    const customilyObserver = new MutationObserver(() => {
        const btn = document.querySelector("#customily-cart-btn");
        if (!btn || btn.dataset._bound) return;
        btn.dataset._bound = "true";

        btn.addEventListener("click", () => {
            const qty = getQuantity();
            const propsAtClick = readCustomilyProperties();

            // Intercetta la fetch di /cart/add.js per leggere l'item appena aggiunto
            const originalFetch = window.fetch;
            window.fetch = async (url, options) => {
                const isAdd = typeof url === "string" && url.includes("/cart/add.js");
                const result = await originalFetch(url, options);

                if (isAdd && result.ok) {
                    window.fetch = originalFetch;
                    const clone = result.clone();
                    let addedItem = null;
                    try { addedItem = await clone.json(); }
                    catch (e) { console.error("[CustomilyFix] Errore lettura add.js", e); }
                    if (addedItem) await fixCartItem(addedItem, qty, propsAtClick);
                }
                return result;
            };
        });
    });

    customilyObserver.observe(document.body, { childList: true, subtree: true });

})();